import { Paragraph } from '../../../../elements/atoms/paragraph/Paragraph';
import { IntroContainer } from '../../../../elements/molecules/introContainer/IntroContainer';
import { Stack } from '../../../../elements/molecules/stack/Stack';

export function QuestionnaireSent() {
    return (
        <IntroContainer style={{ textAlign: 'center' }}>
            <Stack style={{ marginTop: '40px' }}>
                <img
                    alt="Success"
                    src="/assets/images/success.svg"
                    style={{ maxWidth: '60%' }}
                />
            </Stack>
            <Stack>
                <Paragraph>Je antwoorden zijn succesvol verzonden.</Paragraph>
                <Paragraph>Bedankt voor je feedback!</Paragraph>
            </Stack>
        </IntroContainer>
    );
}
